import React from 'react';
import Chip from '@material-ui/core/Chip';


interface Props {
    orderType: number,
}

export default ((props) => {

    var style = { backgroundColor: 'grey', color: 'white', label: 'waiting' };

    switch (props.orderType) {
        case -1:
            style = { backgroundColor: '#4caf50', color: 'white', label: 'Unknown' };
            break;
        case 0:
            style = { backgroundColor: 'orange', color: 'white', label: 'StockOrder' };
            break;
        case 1:
            style = { backgroundColor: 'lightblue', color: 'white', label: 'RxOrder' };
            break;
    }

    return (
        <Chip
            size="small"
            style={{ color: style.color, backgroundColor: style.backgroundColor }}
            label={style.label}
        />)
}) as React.FC<Props>